import { FC, useContext, useState } from 'react'
import styled, { css } from 'styled-components'
import ModalActivityFilter from '@app.feature/activityFilter/screen/ModalActivityFilter'
import { Button } from 'components/custom-material-ui'
import { useBodyScrollHidden } from 'hooks/useBodyScrollHidden'
import SliderIcon from 'svgIcons/Slider'
import { RecruitListScreenContext } from '../../context'

interface RecruitFilterProps {
  className?: string
}

const RecruitFilter: FC<RecruitFilterProps> = ({ className }) => {
  const [isOpen, setIsOpen] = useState(false)
  const { state, dispatch } = useContext(RecruitListScreenContext)
  useBodyScrollHidden(isOpen)

  const handleToggleButton = () => {
    setIsOpen((prev) => !prev)
  }

  return (
    <StyledWrapper className={className}>
      {!isOpen && (
        <div className="slider-button-wrapper">
          <Button onClick={handleToggleButton} className="slider-button">
            <SliderIcon fontSize={'inherit'} />
          </Button>
        </div>
      )}
      <ModalActivityFilter
        filterType="activity"
        activityTypeId={state.activityTypeId}
        onSubmit={(filterBy) => {
          dispatch({
            type: 'FILTER_BY_SET_ALL',
            newState: {
              categoryIDs: filterBy.categoryIDs,
              jobTypes: filterBy.jobTypes,
              orgTypeIDs: filterBy.orgTypeIDs,
              regionIDs: filterBy.regionIDs,
              internTypeIds: filterBy.internTypeIds,
              q: filterBy.q,
            },
          })
          setIsOpen(false)
        }}
        defaultFilterBy={state.filterBy}
        open={isOpen}
        onClose={() => {
          setIsOpen(false)
        }}
      />
    </StyledWrapper>
  )
}

export default RecruitFilter

const StyledWrapper = styled.div`
  ${({ theme }) => css`
    .slider-button-wrapper {
      position: fixed;
      bottom: 70px;
      right: 20px;
      z-index: 1;
    }

    .slider-button {
      width: 50px;
      height: 50px;
      background-color: ${theme.color.primary_2};
      border-radius: 50px;
      box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);
      font-size: 16px;
    }
  `}
`
